// eslint-disable-next-line no-dupe-else-if
import Vue from "vue";
import Router from "vue-router";
import { creatWatermark } from "@/utils/watermark";

Vue.use(Router);

const commonRoutes = [
  {
    path: "/login",
    name: "login",
    meta: { title: "登录" },
    component: () => import("../components/Login.vue"),
  },
  {
    path: "/other", // 点击侧边栏跳到一个单独的路由页面，需要定义，层级和其他顶级路由一样
    name: "other",
    meta: { title: "单独的路由" },
    component: () => import("../views/Other.vue"),
  },
  {
    path: "/404",
    name: "404",
    meta: { title: "404" },
    component: () => import("../components/404.vue"),
  },
  {
    path: "/qrCode",
    name: "qrCode",
    meta: { title: "邀约签到" },
    component: () => import("../views/QRCode/QRCode.vue"),
  },
  // { path: '/', redirect: '/home' },
];

// 本地所有的页面 需要配合后台返回的数据生成页面
export const asyncRoutes = {
  home: {
    path: "home",
    name: "home",
    meta: { title: "主页" },
    component: () => import("../views/Home/Home.vue"),
  },
  homePartner: {
    path: "homePartner",
    name: "homePartner",
    meta: { title: "主页" },
    component: () => import("../views/Home/HomePartner.vue"),
  },
  homeBusiness: {
    path: "homeBusiness",
    name: "homeBusiness",
    meta: { title: "主页" },
    component: () => import("../views/Home/HomeBusiness.vue"),
  },
  notice: {
    path: "notice",
    name: "notice",
    meta: { title: "消息中心" },
    component: () => import("../views/Notice/Notice.vue"),
  },
  visitManage: {
    path: "visitManage",
    name: "visitManage",
    meta: { title: "上门管理" },
    component: () => import("../views/CustomerManage/VisitManage/Index.vue"),
  },
  userManage: {
    path: "userManage",
    name: "userManage",
    meta: { title: "用户管理" },
    component: () =>
      import("../views/SystemConfiguration/UserManage/Index.vue"),
  },
  productManage: {
    path: "productManage",
    name: "productManage",
    meta: { title: "产品管理" },
    component: () => import("../views/ProductManage/index.vue"),
  },
  createUser: {
    path: "createUser",
    name: "createUser",
    meta: { title: "新建用户" },
    component: () =>
      import("../views/SystemConfiguration/RoleManage/CreatUser.vue"),
  },
  editUser: {
    path: "editUser",
    name: "editUser",
    meta: { title: "编辑用户" },
    component: () =>
      import("../views/SystemConfiguration/RoleManage/EditUser.vue"),
  },
  showUser: {
    path: "showUser",
    name: "showUser",
    meta: { title: "当前用户" },
    component: () =>
      import("../views/SystemConfiguration/RoleManage/ShowUser.vue"),
  },

  password: {
    path: "password",
    name: "password",
    meta: { title: "修改密码" },
    component: () => import("../views/Password.vue"),
  },
  msg: {
    path: "msg",
    name: "msg",
    meta: { title: "通知消息" },
    component: () => import("../views/Msg.vue"),
  },
  userinfo: {
    path: "userinfo",
    name: "userinfo",
    meta: { title: "用户信息" },
    component: () => import("../views/UserInfo.vue"),
  },
  customermanage: {
    path: "customermanage",
    name: "customermanage",
    meta: { title: "客户管理" },
    component: () => import("../views/CustomerManage/Index.vue"),
  },
  clueManager: {
    path: "clueManager",
    name: "clueManager",
    meta: { title: "线索管理" },
    component: () => import("../views/clueManager/index.vue"),
  },
  clueDetail: {
    path: "clueDetail",
    name: "clueDetail",
    meta: { title: "线索详情" },
    component: () => import("../views/clueManager/detail.vue"),
  },
  allocationRules: {
    path: "allocationRules",
    name: "allocationRules",
    meta: { title: "分配规则" },
    component: () => import("../views/allocationRules/index.vue"),
  },
  enterManage: {
    path: "enterManage",
    name: "enterManage",
    meta: { title: "进件管理" },
    component: () => import("../views/CustomerManage/enterManage/index.vue"),
  },
  enterDetail: {
    path: "enterDetail",
    name: "enterDetail",
    meta: { title: "进件详情" },
    component: () => import("../views/CustomerManage/enterManage/detail.vue"),
  },
  signManage: {
    path: "signManage",
    name: "signManage",
    meta: { title: "签单管理" },
    component: () => import("../views/CustomerManage/signManage/index.vue"),
  },
  helpCenter: {
    path: "helpCenter",
    name: "helpCenter",
    meta: { title: "帮助中心" },
    component: () => import("../views/helpCenter/index.vue"),
  },
  storeManage: {
    path: "storeManage",
    name: "storeManage",
    meta: { title: "门店管理" },
    component: () => import("../views/StoreManage/Index.vue"),
  },
  callConfiguration: {
    path: "callConfiguration",
    name: "callConfiguration",
    meta: { title: "外呼配置" },
    component: () =>
      import("../views/SystemConfiguration/callConfiguration/index.vue"),
  },
  downloadCenter: {
    path: "downloadCenter",
    name: "downloadCenter",
    meta: { title: "下载中心" },
    component: () => import("../views/download/index.vue"),
  },
  partnerManager: {
    path: "partnerManager",
    name: "partnerManager",
    meta: { title: "合作方管理" },
    component: () => import("../views/partner/index.vue"),
  },
  partnerCreate: {
    path: "partnerCreate",
    name: "partnerCreate",
    meta: { title: "新建合作方" },
    component: () => import("../views/partner/create.vue"),
  },
  partnerEdit: {
    path: "partnerEdit",
    name: "partnerEdit",
    meta: { title: "编辑合作方" },
    component: () => import("../views/partner/edit.vue"),
  },
  partnerDetail: {
    path: "partnerDetail",
    name: "partnerDetail",
    meta: { title: "合作方详情" },
    component: () => import("../views/partner/detail.vue"),
  },
};

const createRouter = () =>
  new Router({
    routes: commonRoutes,
  });

const router = createRouter();

router.beforeEach((to, from, next) => {
  console.log("to.path", to.path);
  if (to.path === "/login" || to.path === "/qrCode") {
    next();
    let oDiv = document.getElementById("watermark_jrkjb");
    if (oDiv) {
      oDiv.parentNode.removeChild(oDiv);
    }
  } else if (
    to.path == "/home" ||
    to.path == "/homePartner" ||
    to.path == "/homeBusiness"
  ) {
    next();
    setTimeout(() => {
      if (localStorage.getItem("token")) {
        creatWatermark("makeClueCenterWatermark");
      }
    }, 0);
  } else {
    next();
  }
});

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
}

// push同一个路由报错
//获取原型对象上的push函数
const originalPush = Router.prototype.push;
//修改原型对象中的push方法
router.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
export default router;
